<template>
  <v-dialog
      v-model="dialog"
      max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Удаление инициатора торгов</span>
      </v-card-title>
      <v-card-text>
        Вы уверенны что хотите удалить: <b>{{ InitiatorName }}</b> ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="dialog=false"
        >
          Нет
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="delInitiator"
        >
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "initiator",
  data: () => ({
    dialog: false,
    id: null,
    InitiatorName: ''
  }),
  beforeDestroy() {
    this.$store.dispatch('modalActionInitiator', null)
  },
  computed: {
    getStoreInitiator() {
      return this.$store.getters.getInitiatorsModal
    }
  },
  watch: {
    getStoreInitiator(val) {
      if(val) {
        this.InitiatorName = val.name
        this.id = val.id
        this.dialog = true
      }
      else {
        this.InitiatorName = ''
        this.id = null
        this.dialog = false
      }
    }
  },
  methods: {
    async delInitiator() {
      if (!this.id) return
      let res = await this.$store.dispatch('deleteInitiator', {id: this.id})
      if (res && res.status === 200) {
        await this.$store.dispatch('modalActionInitiator', null)
      }
      else alert('Что пошло не так!')
    }
  }
}
</script>

<style scoped>

</style>
